// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-polaris-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M10.5 9.506a2.1 2.1 0 0 0 2.106 2.107c1.188 0 2.107-.92 2.107-2.107 0-1.187-.92-2.106-2.107-2.106A2.1 2.1 0 0 0 10.5 9.506zM8.7 16.4a3.898 3.898 0 0 1 3.906-3.906 3.874 3.874 0 0 1 3.907 3.906zM5.88 1.96c0 2.6 1.28 4.12 4.16 4.16-2.68 0-4.04 1.44-4.16 4.16-.04-2.56-1.16-4.16-4.16-4.16 2.68 0 4.16-1.32 4.16-4.16zm3.44 0v1.68m-.84-.84h1.68M3.04 8.36v1.68m-.8-.84h1.64'
  />
);

export const viewBox = '0 0 18 18';
